export enum WorkspaceMessages {
    LEFT_WORKSPACE = 'You have left the workspace.',
    MEMBER_DELETED = 'Member Deleted.',
    INVITES_SENT = 'Invites Sent.',
    INVITE_RESENT = 'Resent invite.',
    ROLE_ASSIGNED = 'Role Assigned.',
}
